import { Usedata} from "./Context/Allcontext";
import Moment from 'moment';
function QiimayaalDahab(){
    const {dahab,q_Fidada} = Usedata()
    const formatDate = Moment().format('DD-MM-YYYY')
    //const formatDate = Date.now()

    return(
        <div className="q cont_qiimayaal">
        <div className="q_dahab nooc_24">
            <div className="icon_qiimo">
                <i className="fa-solid fa-coins"></i>
            </div>
            <div className="qoraal_qii">
                <p>Qiimaha Dahabka 24-ka</p>
                <p>Taariik : {formatDate} </p>
            </div>
            <div className="qiimaha">
                <p><span>{dahab && dahab.price_gram_24k.toFixed(2)}</span>$</p>
            </div>
        </div>
        <div className="q_dahab nooc_24">
            <div className="icon_qiimo">
                <i className="fa-solid fa-coins"></i>
            </div>
            <div className="qoraal_qii">
                <p>Qiimaha Dahabka 22-ka</p>
                <p>Taariik : {formatDate} </p>
            </div>
            <div className="qiimaha">
                <p><span>{dahab && dahab.price_gram_22k.toFixed(2)}</span>$</p>
            </div>
        </div>
        <div className="q_dahab nooc_24">
            <div className="icon_qiimo">
                <i className="fa-solid fa-coins"></i>
            </div>
            <div className="qoraal_qii">
                <p>Qiimaha Dahabka 21-ka</p>
                <p>Taariik : {formatDate} </p>
            </div>
            <div className="qiimaha">
                <p><span>{dahab && dahab.price_gram_21k.toFixed(2)}</span>$</p>
            </div>
        </div>
        <div className="q_dahab nooc_24">
            <div className="icon_qiimo">
                <i className="fa-solid fa-coins"></i>
            </div>
            <div className="qoraal_qii">
                <p>Qiimaha Dahabka 20-ka</p>
                <p>Taariik : {formatDate} </p>
            </div>
            <div className="qiimaha">
                <p><span>{dahab && dahab.price_gram_20k.toFixed(2)}</span>$</p>
            </div>
        </div>
        <div className="q_dahab nooc_24">
            <div className="icon_qiimo">
                <i className="fa-solid fa-coins"></i>
            </div>
            <div className="qoraal_qii">
                <p>Qiimaha Dahabka 18-ka</p>
                <p>Taariik : {formatDate} </p>
            </div>
            <div className="qiimaha">
                <p><span>{dahab && dahab.price_gram_18k.toFixed(2)}</span>$</p>
            </div>
        </div>
        <div className="q_dahab nooc_24">
            <div className="icon_qiimo">
                <i className="fa-solid fa-coins"></i>
            </div>
            <div className="qoraal_qii">
                <p>Qiimaha Fidada 1 Giraam</p>
                <p>Taariik : {formatDate} </p>
            </div>
            <div className="qiimaha">
                <p><span>{q_Fidada && q_Fidada}</span>$</p>
            </div>
        </div>
    </div>
    )
}


export default QiimayaalDahab